// extracted by mini-css-extract-plugin
export var bounce = "_oy-1";
export var generatingText = "_oy-6";
export var lightning = "_oy-4";
export var popup = "_oy-5";
export var progressBar = "_oy-7";
export var progressFill = "_oy-8";
export var progressShimmer = "_oy-9";
export var progressText = "_oy-a";
export var shimmer = "_oy-3";
export var uploadIcon = "_oy-0";
export var uploadingText = "_oy-2";